import { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import axios from '../config/axios'
import Spinner from '../components/Spinner'
import BetkursButtons from '../components/BetKursButtons'
import classes from './BetKursSinglePage.module.css'
import useIsMobile from './../hooks/useIsMobile'

const SERVER_URL = process.env.REACT_APP_SERVER_URL

const BetKursSinglePage = ({ type = 'betcourse' }) => {
  const { id } = useParams()
  const [data, setData] = useState({})
  const scrollRef = useRef(null)
  const isMobile = useIsMobile(1024)

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await axios.get(`/betcourse-post/${id}`)
      setData(data.post)
    }

    fetchData()
  }, [id])

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: 0 })
    }
  }, [data])

  return (
    <div ref={scrollRef} className={classes.mainCenter}>
      <BetkursButtons type={type} />
      <div className={classes.rightPanel}>
        {!data ? (
          <div className={classes.spinner}>
            <Spinner />
          </div>
        ) : (
          <div className={classes.content}>
            <div className={classes.title}>
              <h1>{data.title?.toUpperCase()}</h1>
            </div>
            <div className={classes.contentRow}>
              {data?.items?.map((item, index) => {
                if (item.type === 'text') {
                  return (
                    <div
                      key={index}
                      className={classes.itemText}
                      style={{
                        color: item.color,
                        fontWeight: item.bold ? 'bolder' : false,
                        fontSize:
                          item.fontSize && !isMobile
                            ? `${item.fontSize}px`
                            : '16px',
                        fontStyle: item.italic ? 'italic' : false,
                        marginTop: item.marginTop,
                        marginBottom: item.marginBottom,
                      }}
                    >
                      {item.description}
                    </div>
                  )
                }
                if (item.type === 'video') {
                  return (
                    <video
                      key={index}
                      width='720'
                      height='360'
                      controls
                      style={{ marginBottom: '10px' }}
                      controlsList='nodownload'
                    >
                      <source
                        src={`${SERVER_URL}/${item.video.url}`}
                        type='video/mp4'
                      />
                    </video>
                  )
                }
                if (item.type === 'img') {
                  return (
                    <a
                      key={index}
                      target='_blank'
                      rel='noreferrer'
                      href={item?.imageLink}
                      className={classes.itemImageATag}
                    >
                      <img
                        className={classes.itemImage}
                        src={`${SERVER_URL}/${item.image?.url}`}
                        alt='Item'
                      />
                    </a>
                  )
                }
                return null
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default BetKursSinglePage
